export const tr = {
    'period-from-to': '{from}–{to}'
};
